<template>
  <div id="create">
    <v-container fluid id="edit-profile-view" class="px-5">
      <v-form v-model="validEdit">
        <v-row justify="center" align="center">
          <v-col cols="12" md="6"  >
            <v-card style="height:850px" >
              <v-toolbar color="warning" dark dense flat class="mb-1">
                <v-toolbar-title>
                  Basic details
                </v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_ID"
                        label="Student ID"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_FNAME"
                        label="Student First Name"
                        :counter="20"
                        maxlength="20"
                        
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_MNAME"
                        label="Student Middle Name"
                        :counter="20"
                        maxlength="20"
                        
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_LNAME"
                        label="Student Last Name"
                        :counter="20"
                        maxlength="20"
                        
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="Date of Birth"
                        v-model="BIRTH_DT"
                        
                        :rules="reqRules"
                        required
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        :items="genders"
                        label="Gender"
                        item-text="text"
                        item-value="value"
                        v-model="editedItem.sT_GENDER"
                        
                      >
                      </v-select>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_EMAIL"
                        label="Student Email ID"
                        :counter="50"
                        maxlength="50"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_CELL_NO"
                        label="Student mobile No"
                        :counter="15"
                        maxlength="15"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="6">
            <v-card style="height:850px">
              <v-toolbar color="warning" dark dense flat class="mb-1">
                <v-toolbar-title>
                  Parent details
                </v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>

              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_PAR_FNAME"
                        label="Parent First Name"
                        :counter="20"
                        maxlength="20"
                        
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_PAR_MNAME"
                        label="Parent Middle Name"
                        :counter="20"
                        maxlength="20"
                        
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_PAR_LNAME"
                        label="Parent Last Name"
                        :counter="20"
                        maxlength="20"
                        
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12"> </v-col>

                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_PAR_EMAIL"
                        label="Parent Email ID 1"
                        :counter="50"
                        maxlength="50"
                        
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_PAR_EMAIL1"
                        label="Parent Email ID 2"
                        :counter="50"
                        maxlength="50"
                        
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_PAR_CELL_NO"
                        label="Parent mobile No 1"
                        :counter="15"
                        maxlength="15"
                        
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_PAR_CELL_NO1"
                        label="Parent mobile No 2"
                        :counter="15"
                        maxlength="15"
                        
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12">
            <v-card>
              <v-toolbar color="warning" dark dense flat class="mb-1">
                <v-toolbar-title>
                  Address details
                </v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.sT_ADD1"
                        label="Address1"
                        :counter="30"
                        maxlength="30"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.sT_ADD2"
                        label="Address2"
                        :counter="30"
                        maxlength="30"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.sT_ADD3"
                        label="Address3"
                        :counter="30"
                        maxlength="30"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        :items="territorys"
                        label="Territory name"
                        item-text="tT_NAME"
                        item-value="tT_ID"
                        :rules="reqRules"
                        required
                        
                        v-model="editedItem.sT_SB_TT_ID"
                        :loading="loadingterritory"
                        ref="refterritory"
                      >
                      </v-select>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.city"
                        label="City"
                        :counter="30"
                        maxlength="30"
                        disabled
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="editedItem.sT_PINCODE"
                        label="Pincode"
                        :counter="20"
                        maxlength="20"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card>
              <v-toolbar color="warning" dark dense flat class="mb-1">
                <v-toolbar-title>
                  Emergency Contact details
                </v-toolbar-title>

                <v-spacer></v-spacer>
              </v-toolbar>
              <v-card-text>
                <v-container fluid>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_EM_CONT_NAME"
                        label="Emergency Contact Name"
                        :rules="reqRules"
                        :counter="60"
                        maxlength="60"
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        v-model="editedItem.sT_EM_CONT_PH_NO"
                        label="Emergency Contact No"
                        :counter="25"
                        maxlength="25"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col justify="end" align="end">
            <v-btn color="blue darken-1" text @click="editItem">
              Cancel
            </v-btn>
            <v-btn
              color="blue darken-1"
              :loading="saveLoading"
              text
              @click="saveProfile"
              :disabled="!validEdit"
            >
              Save
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import { get } from "vuex-pathify";
import { showSnackbar } from "../util/globalActions";
import moment from "moment";

export default {
  name: "StudentProfile",

  data: () => ({
    reqRules: [(v) => !!v || "Field is required"],
    validEdit: false,
    permission: {
      isAdd: false,
      isEdit: false,
      isDelete: false,
      isDownload: false,
    },
    genders: [
      {
        text: "Male",
        value: "M",
      },
      {
        text: "Female",
        value: "F",
      },
    ],
    loadingterritory: false,
    saveLoading: false,
    BIRTH_DT: "",
    message: "",
    snackbar: false,
    length: 4,
    tab: null,
    territorys: [],
    editedItem: {
      sT_ID: "",
      sT_FNAME: "",
      sT_MNAME: "",
      sT_LNAME: "",
      sT_TYPE: "",
      sT_BIRTH_DT: null,
      sT_GENDER: "",
      sT_EMAIL: "",
      sT_CELL_NO: "",
      sT_PAR_FNAME: "",
      sT_PAR_MNAME: "",
      sT_PAR_LNAME: "",
      sT_PAR_EMAIL: "",
      sT_PAR_EMAIL1: "",
      sT_PAR_CELL_NO: "",
      sT_PAR_CELL_NO1: "",
      sT_ADD1: "",
      sT_ADD2: "",
      sT_ADD3: "",
      sT_PINCODE: "",
      sT_EM_CONT_NAME: "",
      sT_EM_CONT_PH_NO: "",
      sT_SB_TT_ID: "",
      city: "",
    },
  }),
  created() {
    this.loadTerritory();
  },
  mounted() {
    const self = this;

    self.editItem();
  },
  computed: {
    apiUrl: get("app/apiUrl"),
  },
  watch: {
    "editedItem.sT_SB_TT_ID"(val) {
      const self = this;
      if (self.territorys.length < 0 || self.territorys[0].tT_ID === undefined)
        return;
      
      self.territorys.forEach(element => {
        
        if (element.tT_ID.trim() === val.trim())
        {
          self.editedItem.city = element.city;
        }
          
      });
    },
  },
  methods: {
    editItem() {
      const self = this;

      axios({
        url: self.apiUrl + "api/Users/Profile",
        method: "GET",
      })
        .then(function(res) {
          if (res.data.status === "OK") {
            self.editedItem = res.data.data;
            self.BIRTH_DT = moment(new Date(res.data.data.sT_BIRTH_DT)).format(
              "DD-MMM-YYYY"
            );
          } else {
            showSnackbar({ message: res.data.message });
          }
        })
        .catch(function(err) {
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },

    saveProfile() {
      const self = this;

      self.saveLoading = true;
      axios({
        url: self.apiUrl + "api/Users/updateprofile",
        data: self.editedItem,
        method: "POST",
        responseType: "json",
      })
        .then(function(res) {
          self.saveLoading = false;
          if (res.data.status === "OK")
            showSnackbar({
              message: res.data.message,
              color: "secondary",
            });
          else
            showSnackbar({
              message: res.data.message,
            });
        })
        .catch(function(err) {
          console.log(err);
          self.saveLoading = false;
          self.message = err.status;

          showSnackbar({ message: "Error while update profile!" });
        });
    },
    loadTerritory() {
      const self = this;
      self.loadingterritory = true;
      axios({
        url: self.apiUrl + "api/Territory",
        method: "GET",
      })
        .then(function(res) {
          self.territorys = res.data;
          self.loadingterritory = false;
        })
        .catch(function(err) {
          self.loadingterritory = false;
          self.message = err.status;

          showSnackbar({ message: "Data not found!" });
        });
    },
  },
  beforeDestroy() {},
};
</script>
